import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpand = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M15 3h6v6" }),
		/* @__PURE__ */ _jsx("path", { d: "m21 3-7 7" }),
		/* @__PURE__ */ _jsx("path", { d: "m3 21 7-7" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 21H3v-6" })
	]
});
const ForwardRef = forwardRef(SvgExpand);
export default ForwardRef;
